import { render } from "./transferenciaComponent.vue?vue&type=template&id=3b0af131"
import script from "./transferenciaComponent.vue?vue&type=script&lang=js"
export * from "./transferenciaComponent.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Sendi\\.tools\\sources\\SendiNewClient2.0\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__